import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { Rating } from "react-simple-star-rating";
import Helper from "../../utillity/helper";
import Header from "../Header/Header";
import { NewFooter } from "../NewFooter";
import Blogbg from "../../assets/blog/blogbg.png";
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
export const ProductInfo = () => {
	const state = useLocation().state;

	console.log("product Info", state.product);

	const getCard = (key, value, bgColor) => {
		return (
			<Box
				width={{ xs: "310px", md: "854px" }}
				minWidth={{ xs: "310px", md: "424px" }}
				borderRadius={4}
			>
				<Box
					sx={{
						height: 60,
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						// bgcolor: "#121926",
						bgcolor: bgColor,
						borderRadius: 4,
						px: { xs: 1, md: 4 },
					}}
				>
					<Typography
						fontWeight={600}
						fontSize={{ xs: 14, md: 16 }}
						color={key === "Categories" ? "#FCFCFD" : "121926"}
						alignContent={"center"}
						textTransform={"capitalize"}
					>
						{key}
					</Typography>
					<Typography
						fontWeight={600}
						fontSize={{ xs: 14, md: 16 }}
						color={key === "Categories" ? "#FCFCFD" : "121926"}
						alignContent={"center"}
						textTransform={"capitalize"}
					>
						{value}
					</Typography>
				</Box>
			</Box>
		);
	};
	return (
		<>
			<Box
				sx={{
					background: `url(${Blogbg})`,
					backgroundSize: "100%",
					height: 200,
					// width: "auto",
				}}
			>
				{/* <Box sx={{ p: "20px 14px 20px 14px" }}>
					<Header />
				</Box> */}
				<Box
					display={"flex"}
					flexDirection={"column"}
					justifyContent={"center"}
					textAlign={"center"}
					height={{ xs: 150, md: 160 }}
				>
					{/* <Typography
						component={"h4"}
						variant="inherit"
						fontSize="20"
						fontWeight={500}
						color={"#ffff"}
					>
						Products
					</Typography> */}
					<Typography
						component={"h1"}
						variant="inherit"
						fontSize="58"
						fontWeight={600}
						color={"#ffff"}
					>
						Products Detail
					</Typography>
				</Box>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					p: { xs: 1, md: 4 },
				}}
			>
				<Card
					sx={{
						width: { xs: 310, md: 934 },
						height: 846,
						// gap: 2,
						display: "flex",
						flexDirection: "column",
						// p: 2,
						borderRadius: 4,
					}}
				>
					<Box
						sx={{
							height: 90,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							bgcolor: "#EEF2F6",
						}}
					>
						<Typography
							fontWeight={600}
							fontSize={{ xs: 18, md: 20 }}
							color="#191D23"
							alignContent={"center"}
							textTransform={"capitalize"}
						>
							{"Product Report "}
						</Typography>
					</Box>
					<Box
						sx={{
							width: { xs: 310, md: 854 },
							height: { xs: "auto", md: 248 },
							display: "flex",
							flexDirection: { xs: "column", md: "row" },
							gap: { xs: 0, md: 8 },
						}}
					>
						<Box
							component="img"
							src={state.product.image}
							sx={{ width: { xs: 230, md: 281 }, p: 2 }}
							alt="product image"
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
							}}
						>
							<Typography
								height={{ xs: "auto", md: 160 }}
								fontWeight={600}
								fontSize={{ xs: 18, md: 30 }}
								color="#191D23"
								alignContent={"center"}
							>
								{state.product.title}
							</Typography>
							<Box sx={{ display: "flex", flexDirection: "row" }}>
								<Rating initialValue={state.product.rating} />
								<Typography
									fontWeight={400}
									fontSize={{ xs: 18, md: 28 }}
									color="#697586"
									alignContent={"center"}
								>
									{state.product.rating}
								</Typography>
							</Box>
						</Box>
					</Box>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							gap: { xs: 0, md: 2 },
							mx: "auto",

							py: { xs: "5px", md: "0px" },
						}}
					>
						{getCard("Categories", "Description", "#121926")}
						{getCard(
							"Product income",
							state.product.price_symbol +
								" " +
								Helper.numberFormat(
									typeof state.product.annualPrice === "string"
										? Number(state.product.annualPrice.replace(/\,/g, ""))
										: state.product.annualPrice
								),
							"#FFFFFF"
						)}
						{getCard(
							"Retail Price",
							state.product.price_symbol + " " + state.product.price_value,
							"#EEF2F6"
						)}
						{getCard("Total Reviews:", state.product.ratings_total, "#FFFFFF")}
						{getCard("Amazon ASIN", state.product.asin, "#EEF2F6")}
						{getCard("Category", state.product.category_id, "#FFFFFF")}
						{getCard(
							"Delivery Information:",
							state.product.delivery_tagline_price_is_free === 1
								? "free"
								: "FREE Shipping on orders over $25 shipped by Amazon ",
							"#EEF2F6"
						)}
						{getCard(
							"Prime Eligible:",
							state.product.is_prime ? "Yes" : "No",
							"#FFFFFF"
						)}
					</Box>
				</Card>
			</Box>
		</>
	);
};
